// extracted by mini-css-extract-plugin
module.exports = {"container":"inputFrontBlock_container__2AwiV","noBorder":"inputFrontBlock_noBorder__2bx9y","whiteTheme":"inputFrontBlock_whiteTheme__2UD0o","label":"inputFrontBlock_label__3p_Xu","text":"inputFrontBlock_text__YXc1X","required":"inputFrontBlock_required__13LcN"};
    if(module.hot) {
      // 1783592048517
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  